/* eslint-disable react/jsx-indent */
import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {
  Card, CardBody, Col, CardHeader, ModalFooter,
  Row, ModalHeader, ModalBody,
  Label, FormGroup,
  Spinner} from 'reactstrap'
import oikosApi from '../../../services/oikos';
import qs from 'qs';
import { Backdrop, Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Fade, FormControl, FormControlLabel, FormLabel, InputLabel, MenuItem, Modal, Radio, RadioGroup, Rating, Select, TextField, TextareaAutosize, Typography } from '@mui/material';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import { saveAnexosContaAPagar, getLinkDocumentoDeCobranca, getLinkNotaFiscal, getLinkComprovante, selectValues, parseCurrencyToNumber, notifyExceedingBordero, notifyBordero } from '../../../utils/fc';
import DatePicker from 'react-datepicker';
import SearchableSelect from 'react-select'
import MaskedInput from '../../../components/Template/Input/MaskedInput';
import { currencyFormatter } from '../../../utils/currencyFormatter';
import AddFilesNoForm from '../../../components/Template/Files/AddFilesNoForm';

class Contratacoes extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dataIsLoading: false,
      isModalOpen: false,
    }
  }

  handleSubmit = async () => {
    console.log('cadastrou');
  }

  getOikosId = async (mail) => {
    const res = await oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'pf',
      data: {
        pf_emailProf: mail
      },
      fields: {
      }
    })}`)

    this.setState({userOikosId: res.data[0].pf_id, userCargo: res.data[0].pf_cargo})
  }

  handleCloseModal = () => {
    console.log('teste fechado');
    this.setState({isModalOpen: false});
  };
  handleOpenModal = () => {
    console.log('teste open');
    this.setState({isModalOpen: true});
  };

  render() {

    const { dataIsLoading, isModalOpen, oikos_usuario, oikos_senha, pqGridViewIsOpen, addProductData, addProductModalIsOpen, productDetails  } = this.state
    //const { isManager } = this.props.auth.user

    if (dataIsLoading) {
      return (
        <Card className='centered'>
          <CardBody>
            <span>Carregando...</span>
          </CardBody>
        </Card>
      )
    }

    if (!dataIsLoading) {
      return (
        <>
          <div className='centered'>
            <Button variant="" onClick={this.handleOpenModal}>
              Contratacoes
            </Button>
          </div>
          <Dialog
            fullWidth
            maxWidth= 'md'
            open={isModalOpen}
            onClose={this.handleCloseModal}
            PaperProps={{
              style: {
                margin: 'auto', // Ensures the modal aligns well within the screen center
              },
              component: 'form',
              onSubmit: async (event) => {
                  this.setState({dataIsLoading: true});
                  event.preventDefault();
                  await this.handleSubmit();
                  this.setState({dataIsLoading: false});
              },
            }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle>
              Cadastro de contratação
            </DialogTitle>
              <DialogContent sx={{overflow: "visible"}}>
                <FormControl>
                  <FormLabel id="demo-radio-buttons-group-label">Necessidade de contrato</FormLabel>
                  <RadioGroup
                    row
                    defaultValue={true}
                    name="radio-buttons-group"
                  >
                    <FormControlLabel
                      control={<Radio value="true" />}
                      label="Precisa"
                    />
                    <FormControlLabel
                      control={<Radio value="false" />}
                      label="Não precisa"
                    />
                  </RadioGroup>
                </FormControl>
                <div className="d-flex">
                  <div className='d-flex flex-column flex-fill'>
                    <div className='mt-3'>
                      <TextField
                        fullWidth
                        InputLabelProps={{shrink: true}}
                        label='Descrição'
                        size='small'
                        style={{minWidth: "100px", padding: "8px !important"}}
                      />
                    </div>
                    <div className='mt-3'>
                      <FormControl fullWidth>
                        <InputLabel sx={{backgroundColor: "white", width: "60px", paddingLeft: "5px"}} shrink={true} htmlFor="orcItem">orcItem</InputLabel>

                        <SearchableSelect
                          classNamePrefix="select2-selection"
                          placeholder="Selecionar..."
                          isDisabled={false}
                          isLoading={false}
                          isClearable={true}
                          isSearchable={true}
                        />
                      </FormControl>
                    </div>
                    <div className='mt-3 d-flex flex-row'>
                      <div className='mr-5'>
                        <FormControl fullWidth>
                          <InputLabel sx={{backgroundColor: "white", width: "60px", paddingLeft: "5px"}} shrink={true} htmlFor="orcItem">Valor</InputLabel>

                          <MaskedInput
                            mask="R$ num"
                            blocks={{
                              num: {
                                mask: Number,
                                scale: 2, // digits after point 0 for integers
                                signed: false, // disallow negative
                                thousandsSeparator: '.', // any single char
                                padFractionalZeros: false, // if true then pads zeros at end to the length of scale
                                normalizeZeros: false, // appends or removes zeros at ends
                                radix: ',', // fractional delimiter
                                min: 0,
                                max: 1000000000,
                              },
                            }}
                            lazy={false}
                          />
                        </FormControl>
                      </div>
                      <div className='mr-5'>
                        <FormControl style={{width: "250px"}}>
                          <InputLabel sx={{backgroundColor: "white", width: "60px", paddingLeft: "5px"}} shrink={true} htmlFor="orcItem">Conta</InputLabel>

                          <SearchableSelect
                            classNamePrefix="select2-selection"
                            placeholder="Selecionar..."
                            isDisabled={false}
                            isLoading={false}
                            isClearable={true}
                            isSearchable={true}
                          />
                        </FormControl>
                      </div>
                    </div>
                    <div className='d-flex flex-row mt-3'>
                      <div className='mr-5'>
                        <span>Data Vencimento</span><br/>
                        <DatePicker
                          placeholderText="__/__/_____"
                          locale="pt-BR"
                          className="form-control"
                          dateFormat="dd/MM/yyyy"
                          peekNextMonth
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                        />
                      </div>
                      <div className='mr-5'>
                        <span>Data Quitação</span><br/>
                        <DatePicker
                          placeholderText="__/__/_____"
                          locale="pt-BR"
                          className="form-control"
                          dateFormat="dd/MM/yyyy"
                          peekNextMonth
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                        />
                      </div>
                      <div>
                        <span>Número de parcelas</span><br/>
                        <TextField
                          fullWidth
                          size='small'
                          style={{minWidth: "100px", padding: "8px !important"}}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </DialogContent>
              <DialogTitle>Dados do favorecido</DialogTitle>
              {
                true ?
                (
                  <>
                    <DialogContent sx={{overflow: "visible"}}>
                      <div className="d-flex">
                        <div className='d-flex flex-column flex-fill'>
                          <div>
                            <span>Nome:</span><br/>
                            <FormControl fullWidth>
                              <SearchableSelect
                                classNamePrefix="select2-selection"
                                placeholder="Selecionar..."
                                isDisabled={false}
                                isLoading={false}
                                isClearable={true}
                                isSearchable={true}
                              />
                            </FormControl>
                          </div>
                          <div className='mt-3'>
                            <span>CPF: </span><strong>aaaa</strong>
                          </div>
                          <div className='mt-3'>
                            <span>Dados Bancários:</span><br/>
                            <div className='d-flex flex-column mt-3'>
                              <div className='d-flex flex-column justify-content-between'>
                              <span style={{marginBottom: '3px'}}>Titular: <strong>bbbbb</strong></span>
                              <span style={{marginBottom: '3px'}}>Doc Titular: <strong>ccccc</strong></span>
                              <span style={{marginBottom: '3px'}}>Banco: <strong>dddddd</strong></span>
                              <span style={{marginBottom: '3px'}}>Agência: <strong>eeeeee</strong></span>
                              <span style={{marginBottom: '3px'}}>Número: <strong>ffffff</strong></span>
                              <span style={{marginBottom: '3px'}}>Tipo de conta: <strong>ggggg</strong></span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </DialogContent>
                  </>
                ) : (
                  <DialogContent>
                    <div className="d-flex">
                      <div className='d-flex flex-column flex-fill'>
                        <div>
                          <span>Nome:</span><br/>
                          <FormControl fullWidth>
                            <SearchableSelect
                              classNamePrefix="select2-selection"
                              placeholder="Selecionar..."
                              isDisabled={false}
                              isLoading={false}
                              isClearable={true}
                              isSearchable={true}
                            />
                          </FormControl>
                        </div>
                        <div className='mt-3'>
                          <span>CNPJ: </span><strong>hhhhhh</strong>
                        </div>
                        <div className='mt-3'>
                          <span>Dados Bancários:</span><br/>
                          <div className='d-flex flex-column mt-3'>
                            <div className='d-flex flex-column justify-content-between'>
                            <span style={{marginBottom: '3px'}}>Titular: <strong>iiiiii</strong></span>
                            <span style={{marginBottom: '3px'}}>Doc Titular: <strong>jjjjjj</strong></span>
                            <span style={{marginBottom: '3px'}}>Banco: <strong>kkkkk</strong></span>
                            <span style={{marginBottom: '3px'}}>Agência: <strong>llllll</strong></span>
                            <span style={{marginBottom: '3px'}}>Número: <strong>mmmmmm</strong></span>
                            <span style={{marginBottom: '3px'}}>Tipo de conta: <strong>nnnnnn</strong></span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </DialogContent>
                )
              }
              <DialogActions>
                {dataIsLoading &&(
                  <Button
                    autoFocus
                    margin="dense"
                    id="entregaRevInterna"
                    name="entrega_rev_interna"
                    label="Entrega a Revisao Interna"
                    type="submit"
                    variant="outlined"
                    disabled
                    endIcon={<Spinner/>}
                  >Aguarde</Button>
                )}
                {!dataIsLoading && (
                  <div className="d-flex justify-content-start mb-3">
                      <Button
                      className='text-success'
                      type='submit'
                      >
                        Enviar
                      </Button>
                      <Button
                      onClick={(e) => {
                        e.preventDefault();
                        this.handleCloseModal()
                      }}
                      >
                        Cancelar
                      </Button>
                  </div>
                )}
              </DialogActions>
          </Dialog>
        </>
      )
    }

    return null
  }
}

const mapStateToProps = state => ({ auth: state.auth, technicalDep: state.technicalDep })
const mapDispatchToProps = dispatch => bindActionCreators({
}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(Contratacoes)
